export const hyphenate = (string, regex = /\s/g) => string.replace(regex, "-");

export const hashParamsBrandId = location =>
  window.btoa(
    JSON.stringify({
      location,
    })
  );

export const capitalizeFirstLetter = s => {
  if (typeof s !== "string") return "";
  return s.charAt(0).toUpperCase() + s.slice(1);
};
